import tw from "./tw";
import en from "./en";

export default {
  tw,
  en,
};
